<template>
  <NavComponent :showSearch="false" />
  <section id="courses">
    <div class="colored_banner">
      <h1 v-if="selectedLang.lang">{{ selectedLang.name }}</h1>
      <h1 v-else>Language</h1>
    </div>
    <div class="container">
      

      <div class="row">
        <div class="col-12 col-xs-12" id="courses_container">
          <div class="container-fluid">
            <div class="row">
              <!-- modules section -->
              <div class="col-md-12 col-lg-12 col-xs-12 search_section">
                <div class="section-header">
                  <h2>Modules</h2>
                  <select v-if="modules && modules.length" v-model="modulesSortOrder" class="sort-dropdown">
                    <option value="asc">A-Z</option>
                    <option value="desc">Z-A</option>
                    <option value="date_desc">Date: Newest</option>
                    <option value="date_asc">Date: Oldest</option>
                  </select>
                </div>
                <div v-if="!(modules && modules.length)">
                  <p>No modules to show</p>
                </div>
                <div
                  v-else
                  class="row gy-4 row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-5"
                >
                  <CourseCell
                    v-for="(obj, index) in sortedModules"
                    :key="index"
                    :course="obj"
                  />
                </div>
              </div>

              <!-- courses section hiden for now -->
              <div v-if="false" class="col-md-12 col-lg-12 col-xs-12 search_section">
                <div class="section-header">
                  <h2>Courses</h2>
                  <select v-if="courses && courses.length" v-model="coursesSortOrder" class="sort-dropdown">
                    <option value="asc">A-Z</option>
                    <option value="desc">Z-A</option>
                    <option value="date_desc">Date: Newest</option>
                    <option value="date_asc">Date: Oldest</option>
                  </select>
                </div>
                <div v-if="!(courses && courses.length)">
                  <p>No courses to show</p>
                </div>
                <div
                  v-else
                  class="row gy-4 row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-5"
                >
                  <CourseCell
                    v-for="(obj, index) in sortedCourses"
                    :key="index"
                    :course="obj"
                    :type="'course'"
                  />
                </div>
              </div>

              <!-- videos section -->
              <div class="col-md-12 col-lg-12 col-xs-12 search_section">
                <div class="section-header">
                  <h2>Videos</h2>
                  <select v-if="videos && videos.length" v-model="videosSortOrder" class="sort-dropdown">
                    <option value="asc">A-Z</option>
                    <option value="desc">Z-A</option>
                    <option value="date_desc">Date: Newest</option>
                    <option value="date_asc">Date: Oldest</option>
                  </select>
                </div>
                <div v-if="!(videos && videos.length)">
                  <p>No videos to show</p>
                </div>
                <div
                  v-else
                  class="row gy-4 row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-5"
                >
                  <VideoCell
                    v-for="(obj, index) in sortedVideos"
                    :key="index"
                    :video="obj"
                  />
                </div>
              </div>
            </div>
          </div>

          <Loader :isLoading="isLoading" />
        </div>
      </div>
    </div>
  </section>
  <div id="line"></div>
  <FooterComponent />
</template>
<script>
import { watch, watchEffect, ref } from "vue";
//component
import NavComponent from "@/views/components/Nav";
import FooterComponent from "@/views/components/Footer";

import CourseCell from "@/views/components/CourseCell";
import VideoCell from "@/views/components/VideoCell";
// composables
import GetAllByLang from "@/composables/GetAllByLang";
import GetLanguages from "@/composables/GetLanguages";
export default {
  name: "LangResultView",
  components: {
    NavComponent,
    FooterComponent,
    CourseCell,
    VideoCell,
  },
  data() {
    return {
      loadedData: ref([]),
      data_error: null,
      isLoading: false,
      loadedLanguages: [],
      lang_error: null,
      selectedLang: { name: "Results", lang: null },
      modulesSortOrder: "asc",
      coursesSortOrder: "asc",
      videosSortOrder: "asc",
    };
  },
  mounted() {
    this.load_all_languages()
    const langParam = this.$route.query.key;
    if (langParam) {
      this.selectedLang.lang = langParam
      this.fetchDataResults(langParam);
    }
    this.isLoading = true;
  },
  methods: {
    fetchDataResults(lang) {
      const { loaded_data, data_error, get_data } = GetAllByLang();
      // todo test with updated API that return category parent
      watch([loaded_data, data_error], () => {
        if (loaded_data.value) {
          this.loadedData.value = loaded_data.value;
          this.data_error = null;
          this.isLoading = false;
        }
        if (!this.isRefEmpty(data_error)) {
          this.data_error = data_error.value;
          this.isLoading = false;
        }
      });
      get_data(lang);
    },

    load_all_languages() {
      const { loadedLanguages, lang_error, loadLanguages } = GetLanguages();
      watchEffect(() => {
        // Load languages
        if (!this.isRefEmpty(loadedLanguages)) {
          this.loadedLanguages = loadedLanguages.value;
          console.log('language loaded')
          this.updateLangName(this.loadedLanguages);
          this.lang_error = null;
        }
        if (!this.isRefEmpty(lang_error)) {
          this.lang_error = lang_error.value;
        }
      });
      loadLanguages();
    },
    updateLangName() {
      let foundLanguage = this.loadedLanguages.find(
        (lang) => lang.shortname == this.selectedLang.lang
      );
      if (foundLanguage) {
        this.selectedLang.name = foundLanguage.name; 
        console.log(this.selectedLang)
      }
    },
  },
  computed: {
    courses() {
      if (this.loadedData.value) {
        return this.loadedData.value.courses;
      } else {
        return [];
      }
    },
    modules() {
      if (this.loadedData.value) {
        return this.loadedData.value.modules;
      } else {
        return [];
      }
    },
    videos() {
      if (this.loadedData.value) {
        return this.loadedData.value.videos;
      } else {
        return [];
      }
    },
    sortedCourses() {
      const sorted = [...this.courses];
      sorted.sort((a, b) => {
        if (this.coursesSortOrder === "date_asc" || this.coursesSortOrder === "date_desc") {
          const dateA = new Date(a.created_at || 0).getTime();
          const dateB = new Date(b.created_at || 0).getTime();
          return this.coursesSortOrder === "date_asc" ? dateA - dateB : dateB - dateA;
        } else {
          const nameA = (a.displayname || "").toLowerCase();
          const nameB = (b.displayname || "").toLowerCase();
          return this.coursesSortOrder === "asc"
            ? nameA.localeCompare(nameB)
            : nameB.localeCompare(nameA);
        }
      });
      return sorted;
    },
    sortedModules() {
      const sorted = [...this.modules];
      sorted.sort((a, b) => {
        if (this.modulesSortOrder === "date_asc" || this.modulesSortOrder === "date_desc") {
          const dateA = new Date(a.created_at || 0).getTime();
          const dateB = new Date(b.created_at || 0).getTime();
          return this.modulesSortOrder === "date_asc" ? dateA - dateB : dateB - dateA;
        } else {
          const nameA = (a.displayname || "").toLowerCase();
          const nameB = (b.displayname || "").toLowerCase();
          return this.modulesSortOrder === "asc"
            ? nameA.localeCompare(nameB)
            : nameB.localeCompare(nameA);
        }
      });
      return sorted;
    },
    sortedVideos() {
      const sorted = [...this.videos];
      sorted.sort((a, b) => {
        if (this.videosSortOrder === "date_asc" || this.videosSortOrder === "date_desc") {
          const dateA = new Date(a.created_at || 0).getTime();
          const dateB = new Date(b.created_at || 0).getTime();
          return this.videosSortOrder === "date_asc" ? dateA - dateB : dateB - dateA;
        } else {
          const titleA = (a.title || "").toLowerCase();
          const titleB = (b.title || "").toLowerCase();
          return this.videosSortOrder === "asc"
            ? titleA.localeCompare(titleB)
            : titleB.localeCompare(titleA);
        }
      });
      return sorted;
    },
  },
};
</script>

<style scoped >
.search_section {
  margin-bottom: 60px;
}
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
  margin-bottom: 10px;
}
.section-header h2 {
  margin: 0;
}
.sort-dropdown {
  padding: 6px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  background-color: white;
  transition: border-color 0.3s;
}
.sort-dropdown:hover {
  border-color: #999;
}
.sort-dropdown:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}
</style>